module.exports = __webpack_public_path__ + "img/coin-icon.bf5b470d.svg";